import {Pipe, PipeTransform} from '@angular/core';

export function formatCriteriaWeight(weight: number | null): string {
  return weight === null ? '–' : `${(weight * 100).toFixed(2)}%`;
}

@Pipe({
  name: 'criteriaWeight',
})
export class CriteriaWeightPipe implements PipeTransform {
  transform(weight: number | null): string {
    return formatCriteriaWeight(weight);
  }
}
